// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Buy_cards} from './buy_cards';
import {oculus_img_url} from '../../../../hola/pub/ui/oculus_img_url';
import Icon_check_circle from '../../img/icons/16/check_circle_color.svg';
import Icon_sneakers from '../../img/icons/24/sneakers.svg';
import Icon_events from '../../img/icons/24/events.svg';
import Icon_chevron_right from '../../img/icons/24/chevron_right.svg';
import {Button} from '../../lib/button';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {oculus_proxy_type} from '../../types';
import {products} from '../products';
import styles from './pricing_section.module.less';
import {Period_slider} from './period_slider';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import {www_hola} from 'hola_opt';
import {Editor} from '../../../../shared/editor/editor';

interface i_pricing_section_props {
    type: oculus_proxy_type,
    with_checks?: boolean;
}

const PERIOD_FORMAT = {
  '1w': '1 W',
  '1m': '1 M'
};

interface i_alert_banner_props {
    short?: boolean;
}

const Alert_banner =(props: i_alert_banner_props)=>{
    const {theme} = useContext(Settings_context);
    const title = props.short ? 'Short KYC verification after payment' :
        'Quick identity check required to proceed';
    return <div className={styles.kyc_wrapper}>
      <div className={styles.kyc_banner}>
        <Icon_check_circle/>
        <p className={cn(theme.p14, theme.med)}>
          {title}
        </p>
        <div className={styles.kyc_tooltip}>
          <p className={cn(theme.p12, theme.med, theme.color_n000)}>
            Our quick identity verification process includes a valid ID card
            check and facial recognition
          </p>
        </div>
      </div>
    </div>;
};

interface i_period_slider_props {
    is_lobby_page?: boolean;
}

export const Contact_banner = (props: i_period_slider_props)=>{
    const {theme} = useContext(Settings_context);
    const {is_lobby_page} = props;
    const contact_handler = ()=>{
        window.location.href = 'mailto:support@oculusproxies.com';
    };
    return <div className={cn(styles.contact, is_lobby_page &&
      styles.contact_lobby)}>
      <div className={styles.svg}>
        <img src={oculus_img_url('products.svg')}/>
      </div>
      <p className={cn(theme.p18, theme.bold, styles.contact_text,
        theme.color_n700)}>
        Need help finding the right proxy package for you?
      </p>
      <Button caption={'Contact us'} color={'secondary'} round={false}
        cls={styles.contact_button} on_click={contact_handler}
      />
    </div>;
};

export const Better_fit_resi_banner = ({on_click=null})=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.better_fit_resi_banner}>
      <div className={styles.better_fit_resi_icons}>
        <div className={styles.icon_container}><Icon_events /></div>
        <div className={styles.icon_container}><Icon_sneakers /></div>
      </div>
      <div className={styles.better_fit_resi_text}>
        <p className={cn(theme.p18, theme.bold, theme.color_n700)}>
          Are you looking for best residential proxies for
          <span> Events tickets</span> or <span>Sneakers sites?</span>
        </p>
        <p className={cn(theme.p16)}>Choose from the following proxy plans:</p>
      </div>
      <div className={styles.better_fit_resi_btns}>
          <Button caption='Events Tickets Proxies' color='secondary'
            icon_right={<Icon_chevron_right />} size='s' width={205}
            {...(on_click ? {on_click: ()=>on_click('events_resi_tickets')} :
              {to: '/pricing/events-resi-tickets'})} />
          <Button caption='Sneakers Proxies' color='secondary'
            icon_right={<Icon_chevron_right />} size='s' width={205}
            {...(on_click ? {on_click: ()=>on_click('resi_sneakers')} :
              {to: '/pricing/resi-sneakers'})} />
      </div>
    </div>;
};

interface i_pricing_section_props_ed {
    value: i_pricing_section_props;
    on_change: (v:i_pricing_section_props)=>void;
    on_cancel: ()=>void;
}
export const Pricing_section_editor = (props: i_pricing_section_props_ed)=>{
    const [state, set_state] = useState<i_pricing_section_props>(props.value);
    return <Editor
      value={state}
      editors={[
        {key: 'type', label: 'id_product', type: 'text'},
      ]}
      on_change={v=>set_state(v)}
      on_save={()=>props.on_change(state)}
      on_cancel={props.on_cancel}/>;
};

export const Pricing_section = (props: i_pricing_section_props)=>{
    const {type, with_checks = true} = props;
    const {theme} = useContext(Settings_context);
    const {qs} = use_qs_with_set();
    const product = products[type];
    const {width} = use_screen();
    const selected_product = product || 'Dedicated Datacenter';
    const title = `${product} Proxies Pricing`;
    const show_period_slider = www_hola.pricing_types_with_period
      .includes(type);
    const current_period = qs.period || '1w';
    return <div className={cn(theme.container, styles.container)}>
      {width > 768 ? <div className={cn(styles.head_line)}>
        <h3>{title}</h3>
      </div> : <div className={cn(styles.head_line_mobile)}>
        <h4>{title}</h4>
      </div>}
      {show_period_slider && <div className={styles.slider}>
        <Period_slider/>
      </div>}
      {type == 'events_resi_tickets' && <Alert_banner/>}
      <div className={styles.pricing_table}>
        <Buy_cards product={selected_product} type={type}
          with_checks={with_checks}
          current_period={PERIOD_FORMAT[current_period]}/>
      </div>
      <div className={styles.banner_container}>
        <Contact_banner/>
      </div>
    </div>;
};
